import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ZoneGeographiqueDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-zone-geographique',
  templateUrl: './zone-geographique.component.html',
  styleUrls: ['./zone-geographique.component.css']
})
export class ZoneGeographiqueComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.zonesGeographiques$) zonesGeographiques$: Observable<ZoneGeographiqueDto[]>;

  @Input('zoneGeographiqueId') public zoneGeographiqueId: number;

  ZoneInComponent: ZoneGeographiqueDto;

  zg: Subscription;

  constructor() { }

  ngOnInit() {
    this.zg = this.zonesGeographiques$.subscribe(res => {
      if (res != null) {
        let zone = res.filter(u => u.Id == this.zoneGeographiqueId);
        this.ZoneInComponent = zone.length == 1 ? zone[0] : { Nom: null };
      }
    });
  }

  ngOnDestroy() {
    this.zg?.unsubscribe();
  }

}
